import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: HomePage
    },
    {
      path: '/callus',
      component: () => import('@/views/callus'),
      hidden: true
    },
    {
      path: '/resource',
      component: () => import('@/views/resource'),
      hidden: true
    },
    {
      path: '/rebuild',
      component: () => import('@/views/RebuildPage')
    },
    {
      path: '/invest',
      component: () => import('@/views/InvestPage')
    },
    {
      path: '/health',
      component: () => import('@/views/HealthPage')
    },
    {
      path: '/iot',
      component: () => import('@/views/IotPage')
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js